import { useEffect } from 'react';
import { PageProps } from 'gatsby';
import { navigate } from '@gatsbyjs/reach-router';

const getLocaleAware404Path = (location): string => {
  const locale = location.pathname.split('/')[1];
  const countryList = [
    'bg-en',
    'ch-de',
    'ch-en',
    'de-de',
    'es-en',
    'fr-fr',
    'hr-en',
    'hu-en',
    'it-it',
    'li-de',
    'lu-en',
    'pl-en',
    'ro-en',
    'si-en',
    'sk-en',
    'at-de',
    'at-en',
    'at-rsi',
    'at-golfmeisterschaft',
  ];
  if (!locale || !countryList.includes(locale)) {
    return '/not-found/';
  }

  return `/${locale}/404/`;
};

const NotFound = ({ location }: PageProps): JSX.Element => {
  useEffect(() => {
    const maskUrl = window.location.href;
    navigate(getLocaleAware404Path(location), {
      replace: false,
      state: { maskUrl },
    });
    navigate(0);
  }, []);

  return null;
};

// eslint-disable-next-line import/no-default-export
export default NotFound;
